import React from 'react';

const TabNavigation = ({ activeTab, setActiveTab }) => {
  const tabs = ['Videos', 'Reels', 'Stories'];

  return (
    <div className="w-full px-12 mt-1">
      <div className="flex space-x-8 border-b-[2px] border-[#eff2f9]">
        {tabs.map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-3.5 font-bold text-[14px] transition-colors relative  f-fam-name-spline-sans ${
              activeTab === tab ? 'text-[#7818D2] ' : 'text-[#6E6E6E] border-b-[3px] border-[#E5E8EB] hover:text-[#7818D2]'
            }`}
          >
            {tab}
            {activeTab === tab && (
              <div className="absolute bottom-[0px] left-0 right-0 h-[3px] bg-[#7818D2] rounded-t-sm" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
